import { render, staticRenderFns } from "./AdvertisementPrintComponent.vue?vue&type=template&id=f522fe5c&scoped=true&"
import script from "./AdvertisementPrintComponent.vue?vue&type=script&lang=js&"
export * from "./AdvertisementPrintComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementPrintComponent.vue?vue&type=style&index=0&id=f522fe5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f522fe5c",
  null
  
)

export default component.exports